var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBolt(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 16,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.167 15.5h-.834l.834-5.833H1.25c-.733 0-.275-.625-.258-.65C2.067 7.117 3.683 4.283 5.842.5h.833l-.833 5.833h2.925c.333 0 .516.159.333.55A6504.846 6504.846 0 004.167 15.5z",
    fill: "#005FFF"
  })));
}
export default SvgBolt;